<template>
  <v-container fluid>
    <!-- EDIT TOOL MODAL -->
    <v-dialog v-model="editDialog" persistent max-width="600px">
      <v-card class="pa-0 pb-4">
        <v-card-title>
          <h2 class="headline pa-3">Edit Tool</h2>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" align="left">
                <v-img
                  :src="currentTool.image"
                  width="150"
                  height="150"
                  contain
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Tool Name"
                  required
                  v-model="currentTool.title"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="currentTool.category"
                  :items="[
                    'General',
                    'Gas Powered',
                    'Pneumatic',
                    'Electrical',
                    'Safety',
                    'Scaffolding',
                    'Vehicles',
                    'Storage',
                    'Environmental',
                  ]"
                  label="Category"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Description"
                  required
                  v-model="currentTool.description"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Tool ID"
                  required
                  v-model="currentTool.toolId"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Shelf ID"
                  required
                  v-model="currentTool.shelfId"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="currentTool.keyFeature1"
                  label="Key Feature 1"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="currentTool.keyFeature2"
                  label="Key Feature 2"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Unit Price"
                  required
                  type="number"
                  v-model.number="currentTool.unitPrice"
                  :rules="[(v) => !!v || 'Unit price is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  multiple
                  v-model="currentTool.tags"
                  chips
                  deletable-chips
                  append-icon
                  label="Add tags to make search easier."
                  hint="Click Enter or Tab key to keep adding."
                  persistent-hint
                ></v-combobox>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  color="primary"
                  label="Consumable"
                  v-model="currentTool.consumable"
                  :persistent-hint="true"
                  hint="If consumable, this tools inventory will not be tracked. Example: Dust Mask."
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mr-4">
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="editDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="updateTool">Save Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- NEW TOOL MODAL -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card class="pa-0 pb-4">
        <v-card-title>
          <h2 class="headline pa-3">Add New Tool</h2>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="image-preview-wrapper" v-if="imageUrl">
                    <img :src="imageUrl" height="150" />
                  </div>
                  <v-text-field
                    label="Select Image"
                    @click="pickFile"
                    v-model="imageName"
                    :rules="[(v) => !!v || 'Image required']"
                    prepend-icon="attach_file"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Tool Name"
                    required
                    v-model="newTool.title"
                    :rules="[(v) => !!v || 'Title is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="newTool.category"
                    :items="[
                      'General',
                      'Gas Powered',
                      'Pneumatic',
                      'Electrical',
                      'Safety',
                      'Scaffolding',
                      'Vehicles',
                      'Storage',
                      'Environmental',
                    ]"
                    label="Category"
                    :rules="[(v) => !!v || 'Category is required']"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Description"
                    required
                    v-model="newTool.description"
                    :rules="[(v) => !!v || 'Description required']"
                    auto-grow
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Tool ID"
                    required
                    v-model="newTool.toolId"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Shelf ID"
                    required
                    v-model="newTool.shelfId"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newTool.keyFeature1"
                    label="Key Feature 1"
                    auto-grow
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newTool.keyFeature2"
                    label="Key Feature 2"
                    auto-grow
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Unit Price"
                    required
                    type="number"
                    v-model.number="newTool.unitPrice"
                    :rules="[(v) => !!v || 'Unit price required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-combobox
                    multiple
                    v-model="newTool.tags"
                    chips
                    deletable-chips
                    append-icon
                    label="Add tags to make search easier."
                    hint="Click Enter or Tab key to keep adding."
                    persistent-hint
                  ></v-combobox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    color="primary"
                    label="Consumable"
                    v-model="newTool.consumable"
                    :value="false"
                    :persistent-hint="true"
                    hint="If consumable, this tools inventory will not be tracked. Example: Dust Mask."
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="mr-4">
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="addTool" :disabled="!valid"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- TOOL LIST -->
    <v-row wrap justify="center">
      <v-col cols="11" xs="12" class="headline">
        Tool List
        <v-btn class="ml-3" color="primary" small @click.stop="dialog = true">
          <v-icon small class="mr-2">add</v-icon>Add New
        </v-btn>
        <span class="ml-4 caption grey--text"
          >Tool Count: {{ tools.length }}</span
        >
      </v-col>
      <v-col cols="11" xs="12">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="tools"
            :search="search"
            :loading="loading"
            :items-per-page="20"
            loading-text="Loading Tool List..."
            id="tool-list-table"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Filter by key words"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.image="{ item }">
              <div class="py-2">
                <v-img :src="item.image" width="60" height="60" contain />
              </div>
            </template>
            <template v-slot:item.title="{ item }">
              <div>{{ item.title }}</div>
              <div class="caption grey--text d-none">ID: {{ item.id }}</div>
              <div class="caption grey--text" v-if="item.consumable">
                Tool not tracked (consumable)
              </div>
            </template>
            <template v-slot:item.description="{ item }">
              <div>{{ item.description }}</div>
              <ul
                class="grey--text d-none d-md-block"
                style="line-height:1.4em"
              >
                <li v-if="item.keyFeature1">{{ item.keyFeature1 }}</li>
                <li v-if="item.keyFeature2">{{ item.keyFeature2 }}</li>
              </ul>
              <div class="caption grey--text">ID: {{ item.id }}</div>
            </template>
            <template v-slot:item.unitPrice="{ item }"
              >${{ item.unitPrice.toFixed(2) }}</template
            >
            <template v-slot:item.tool_id="{ item }">
              <v-btn
                class="mr-2"
                color="primary"
                text
                small
                outlined
                @click="editTool(item)"
                ><v-icon small left>edit</v-icon> Edit</v-btn
              >
              <v-btn
                color="primary"
                text
                small
                outlined
                v-if="!item.consumable"
                :to="`/tools/manage/find-tool/${item.id}`"
                ><v-icon small left>my_location</v-icon> locate</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- loading -->
    <Loader text="Adding new tool..." />
    <Snackbar text="Successfully added tool" color="success" timeout="3000" />
  </v-container>
</template>
<script>
import fb from "@/main";
import Loader from "@/components/Loader";
import Snackbar from "@/components/Snack";
import { round } from "lodash";
export default {
  components: { Loader, Snackbar },
  data() {
    return {
      search: "",
      valid: true,
      loading: true,
      round: round,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 80,
        },
        { text: "Name", value: "title" },
        { text: "Description", value: "description" },
        { text: "Unit Price", value: "unitPrice" },
        { text: "Tool Category", value: "category" },
        { text: "", value: "tool_id", align: "right", width: "250" },
      ],
      newTool: {},
      currentTool: {},
      tools: [],
      dialog: false,
      editDialog: false,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      toolOptions: [{ title: "Find Tool" }],
    };
  },
  methods: {
    async addTool() {
      this.$store.commit("loading", true);
      try {
        // adjustments before creating
        this.newTool.unitPrice = parseFloat(this.newTool.unitPrice);
        this.newTool.tagList = this.newTool.tags
          ? this.newTool.tags.join(", ")
          : "";
        const newToolRes = await fb.db.collection("tools").add(this.newTool);
        // add image after saving new tool
        var storageRef = fb.storage.ref();
        var toolImageRef = storageRef.child(`toolImages/${this.newTool.title}`);
        console.log("newToolRes.id", newToolRes.id);
        toolImageRef.put(this.imageFile).then((snapshot) => {
          snapshot.ref.getDownloadURL().then(async (downloadURL) => {
            console.log("newToolRes.id after", newToolRes.id);
            console.log("downloadURL", downloadURL);
            await fb.db
              .collection("tools")
              .doc(newToolRes.id)
              .set(
                {
                  image: downloadURL,
                },
                { merge: true }
              );

            // get tools again and reset
            this.newTool = {};
            // await this.getTools();
            this.newTool = {};
            this.dialog = false;
            this.imageName = "";
            this.imageFile = "";
            this.imageUrl = "";
            this.$store.commit("loading", false);
          });
        });
      } catch (error) {
        alert(error);
        this.$store.commit("loading", false);
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    async getTools() {
      const tools = await fb.db.collection("tools").get();
      tools.forEach((u) => {
        this.tools.push({
          id: u.id,
          ...u.data(),
        });
      });
      console.log(this.tools);

      this.loading = false;
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0];
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    editTool(tool) {
      this.currentTool = { ...tool };
      console.log(this.currentTool);
      this.editDialog = true;
    },
    async updateTool() {
      try {
        this.$store.commit("loading", true);
        const toolId = this.currentTool.id;
        delete this.currentTool["id"];
        this.currentTool.unitPrice = parseFloat(this.currentTool.unitPrice);
        this.currentTool.tagList = this.currentTool.tags
          ? this.currentTool.tags.join(", ")
          : "";
        console.log(this.currentTool);
        await fb.db
          .collection("tools")
          .doc(toolId)
          .update(this.currentTool);
        this.editDialog = false;
        this.currentTool = {};
        this.$store.commit("loading", false);
      } catch (error) {
        console.log(error);
        alert("Unable to save changes: ", error);
        this.$store.commit("loading", false);
      }
    },
  },
  async created() {
    const that = this;
    await fb.db.collection("tools").onSnapshot(function(querySnapshot) {
      var tools = [];
      querySnapshot.forEach(function(doc) {
        tools.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      that.tools = tools;
    });
    this.loading = false;
  },
};
</script>

<style>
.image-preview-wrapper {
  border: solid 1px #ececec;
  display: inline-block;
  padding: 20px;
  margin-bottom: 20px;
}
#tool-list-table td.v-data-table__mobile-row:first-of-type {
  height: 110px;
}
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
  list-style-type: none !important;
}
</style>
